import { I18n } from '@affine/i18n';

const CODE = 'DEMO_NAME_BLOCKED';

/** Nest/GraphQL clients wrap the same domain code at different depths. */
export function isDemoNameBlockedError(error: unknown): boolean {
  const seen = new Set<object>();
  const visit = (value: unknown, depth: number): boolean => {
    if (depth > 6 || !value) return false;
    if (typeof value === 'string') return value.includes(CODE);
    if (typeof value !== 'object' || seen.has(value)) return false;
    seen.add(value);
    const record = value as Record<string, unknown>;
    if (record.code === CODE) return true;
    if (value instanceof Error && value.message.includes(CODE)) return true;
    return [
      record.extensions,
      record.originalError,
      record.response,
      record.cause,
      record.graphQLErrors,
      record.errors,
    ].some(nested =>
      Array.isArray(nested)
        ? nested.some(item => visit(item, depth + 1))
        : visit(nested, depth + 1)
    );
  };
  return visit(error, 0);
}

export function demoNameBlockedNotice(): string {
  return String(I18n.language).toLowerCase().startsWith('de')
    ? 'Dieser Name ist in der öffentlichen Demo nicht erlaubt. Bitte wähle einen neutralen Namen.'
    : 'This name is not allowed in the public demo. Please choose a neutral name.';
}

export function demoContentRemovedNotice(): string {
  return I18n.t('com.streamlain.demo.content-removed');
}
